<template>
  <AppHeader />

  <div class="container mx-auto p-4">
    <div
      class="max-w-screen-2x1 mx-auto bg-white dark:bg-slate-800 rounded-lg shadow-md overflow-hidden
             text-gray-900 dark:text-gray-100"
    >
      <!-- Header / Filters -->
      <div class="p-4 border-b dark:border-slate-700 flex items-center justify-between flex-wrap gap-3">
        <div>
          <h1 class="text-xl font-semibold">Visão Geral (Admin)</h1>
        </div>

        <div class="flex items-center gap-2">
          <select
            v-model="filters.unit"
            :disabled="isManager"
            class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700"
          >
            <template v-if="isManager">
              <option :value="userUnit">{{ userUnit }}</option>
            </template>
            <template v-else>
              <option value="">Todas as unidades</option>
              <option value="GPI">GPI</option>
              <option value="GEOF">GEOF</option>
              <option value="GEAAL">GEAAL</option>
            </template>
            
          </select>

          <select
            v-model="filters.collaborator"
            class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700"
          > 
            <option value="">Marque um nome</option>
            <option v-for="colaborador in colaboradores" :key="colaborador" :value="colaborador">
            {{ colaborador }}
            </option>
            
            
          </select>

          <select
            v-model="filters.analyzed_item"
            class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700"
          >
            <option value="">Marque um item a ser analisado</option>
            <option value="Pontos">Pontos</option>
            <option value="Entregas">Entregas</option>
            <option value="Horas trabalhadas">Horas trabalhadas</option>
            
            
          </select>

          <input
            v-model="filters.from"
            type="date"
            class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700"
          />
          <input
            v-model="filters.to"
            type="date"
            class="px-3 py-2 border rounded-md dark:bg-slate-800 dark:border-slate-700"
          />

          <button
            @click="resetFilters"
            class="px-3 py-2 rounded-md bg-slate-600 text-white hover:bg-slate-700"
          >
            Limpar Filtro
          </button>

          <button
            @click="loadCharts"
            class="px-3 py-2 rounded-md bg-slate-600 text-white hover:bg-slate-700"
          >
            Pesquisar
          </button>
        </div>

        <!-- Date presets + column toggle -->
        <div class="w-full flex items-center gap-2">
          <div class="flex items-center gap-2">
            <button class="px-2 py-1 text-xs rounded-lg border dark:border-slate-600"
                    @click="setPreset('today')">Hoje</button>
            <button class="px-2 py-1 text-xs rounded-lg border dark:border-slate-600"
                    @click="setPreset('week')">Esta semana</button>
            <button class="px-2 py-1 text-xs rounded-lg border dark:border-slate-600"
                    @click="setPreset('month')">Este mês</button>
          </div>

        
        </div>
      </div>

      <!-- Stats bar -->
      <div class="px-4 pt-4 grid grid-cols-1 sm:grid-cols-4 gap-3">
        <div class="p-3 rounded-lg bg-gray-50 dark:bg-slate-700/50">
          <div class="text-xs text-gray-500 dark:text-gray-300">Entregas</div>
          <div class="text-lg font-semibold">{{ total_entregas }}</div>
        </div>
        <div class="p-3 rounded-lg bg-gray-50 dark:bg-slate-700/50">
          <div class="text-xs text-gray-500 dark:text-gray-300">Total (horas)</div>
          <div class="text-lg font-semibold">{{ this.fmtDuration(total_horas) }}</div>
        </div>
        <div class="p-3 rounded-lg bg-gray-50 dark:bg-slate-700/50">
          <div class="text-xs text-gray-500 dark:text-gray-300">Média de horas trabalhadas</div>
          <div class="text-lg font-semibold">{{ this.fmtDuration(media_horas) }}</div>
        </div>
        <div class="p-3 rounded-lg bg-gray-50 dark:bg-slate-700/50">
          <div class="text-xs text-gray-500 dark:text-gray-300">Intervalo ativo</div>
          <div class="text-sm">{{ filters.from || '—' }} → {{ filters.to || '—' }}</div>
        </div>
      </div>
      <div class="p-4 grid grid-cols-1 md:grid-cols-2 gap-6">

        <!-- Barras por gerência -->
        <div class="bg-gray-50 dark:bg-slate-700/50 rounded-lg p-4">
            <h2 class="text-sm font-semibold mb-2">Por Gerência</h2>
            <BarChart v-if="barData" 
            :chart-data="barData"
            :chart-options="barOptions" />
        </div>

        <!-- Barras por colaborador -->
        <div class="bg-gray-50 dark:bg-slate-700/50 rounded-lg p-4">
            <h2 class="text-sm font-semibold mb-2">Por Colaborador</h2>
            <BarChart v-if="barData_2" 
            :chart-data="barData_2"
            :chart-options="barOptions" />
        </div>

        <!-- Rosca por atividade -->
        <div class="bg-gray-50 dark:bg-slate-700/50 rounded-lg p-4">
            <h2 class="text-sm font-semibold mb-2">Por Atividade</h2>
            <DoughnutChart v-if="doghnutData" 
            :chart-data="doghnutData"
            :chart-options="doughnutOptions" />
        </div>

        <!-- Linha por mês -->
        <div class="bg-gray-50 dark:bg-slate-700/50 rounded-lg p-4">
            <h2 class="text-sm font-semibold mb-2">Por Mês</h2>
            <LineChart v-if="lineData" 
            :chart-data="lineData"
            :chart-options="lineOptions" />
        </div>

      </div>

    </div>

    <div class="fixed top-4 right-4 z-50" v-if="error">
      <div class="px-4 py-2 rounded-md bg-red-600 text-white shadow">{{ error }}</div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import AppHeader from './Header.vue'
import { processos_GEOF, hierarquia_GEOF, weight_complexity_GEOF } from "./GEOF";
import { BarChart, LineChart, DoughnutChart } from './Chart';

export default {
  name: 'AdminEntries',
  components: { AppHeader, BarChart, LineChart, DoughnutChart },
  data() {
    const isLocal = ['localhost', '127.0.0.1'].includes(window.location.hostname)
    return {
      apiBase: isLocal ? 'http://localhost:5000' : '/api',

      rows: [],
      error: '',
      loading: false,

      //Summary
      total_horas: null,
      total_entregas: null,
      media_horas: null,

      // filters
      filters: { unit: '', q: '', from: '', to: '', collaborator: '', analyzed_item: '' },

      // sorting
      sort: { key: 'gerencia', dir: 'asc' },

      // summary/grouping
      groupBy: 'unit',
      summary: [],

      // UI toggles
      showNotes: true,

      // debounce timer (fixed: no underscore)
      filterTimer: null,

      //Tasks, dispatches, processes and complexity 's objects
      processos_GEOF,
      hierarquia_GEOF,
      weight_complexity_GEOF,

      //Manager verifier
      isManager: false,
      userUnit: '',
      user: '',

      //Gráficos
      colaboradores: [],
      doughnutOptions: null,
      lineOptions: null,
      barOptions: null,
      barData: null,
      lineData: null,
      doghnutData: null,
      barData_2: null
    }
  },
  computed: {
    sorted() {
      const arr = [...this.rows]
      const k = this.sort.key
      const dir = this.sort.dir === 'asc' ? 1 : -1
      return arr.sort((a, b) => {
        const va = String(a[k] || '').toUpperCase()
        const vb = String(b[k] || '').toUpperCase()
        return va.localeCompare(vb) * dir
      })
    },
    totalMinutes() {
      return this.rows.reduce(
        (s, r) => s + (Number.isFinite(r.time_duration) ? r.time_duration : 0),
        0
      )
    },
    avgPerEntry() {
      if (!this.rows.length) return '0h 0m'
      const avg = Math.round(this.totalMinutes / this.rows.length)
      const h = Math.floor(avg / 60)
      const m = avg % 60
      return `${h}h ${m}m`
    },
    //Mapear as labels de hierarquia_GEOF
    geofLabelMap() {
      const map = {}, submission = {}, complexity = {}

      this.hierarquia_GEOF.forEach(proc => {

        // processo
        map[proc.id] = proc.label

        // entregas
        proc.entrega?.forEach(a => {
          map[a.id] = a.label
          submission[a.id] = a.submission
          complexity[a.id] = a.complexity
        })

        // tarefas
        proc.tarefa?.forEach(e => {
          map[e.id] = e.label
        })

      })

      return { map, submission, complexity}
    },
  },
  mounted() {
    const observer = new MutationObserver(() => {
      this.loadCharts()
    })
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    })
  },
  async created() {
    try {
      const raw = localStorage.getItem('user')
      console.log(raw)
      this.user = raw ? JSON.parse(raw) : {}
      this.userUnit = this.user.unit.toUpperCase()
      if ((this.user.manager == 1 || this.user.manager == true) && (this.user.admin == 0 || this.user.admin == false)) {
        this.isManager = true
      }
      else this.isManager = false
      if (this.isManager) this.filters.unit = this.userUnit

    }catch(e) {
      console.debug('manager preselect unit: parse error', e);
    }
    
    await this.loadUsers (this.filters.unit)
    this.loadCharts()
  },
  methods: {
    async loadCharts() {
        try {
            const params = {}
            if (this.filters.unit) params.unit = this.filters.unit
            if (this.filters.q)    params.q    = this.filters.q
            if (this.filters.from) params.from = this.filters.from
            if (this.filters.to)   params.to   = this.filters.to
            if (this.filters.collaborator) params.collaborator = this.filters.collaborator
            
            const { data } = await axios.get(`${this.apiBase}/admin/overview`, { params })
            
            //Dados para a tabela resumo
            this.total_entregas = data.by_summary.total_entregas
            this.total_horas = data.by_summary.total_horas
            this.media_horas = data.by_summary.media_horas

            //Retornar o valor do item selecionado para análise
            const getItem = (m) => {
            if (this.filters.analyzed_item === "Pontos")           return m.total_pontos;
            if (this.filters.analyzed_item === "Entregas")         return m.total_entregas;
            if (this.filters.analyzed_item === "Horas trabalhadas") return m.total_minutos;
            return m.total_entregas;
            }

            //Organização dos rótulos
            const getLabel = () => {
                if (this.filters.analyzed_item === "Pontos")           return 'Pontos por';
                if (this.filters.analyzed_item === "Entregas")         return 'Entregas por';
                if (this.filters.analyzed_item === "Horas trabalhadas") return 'Horas trabalhadas por';
                return 'Valores por'
            }

            const getLabelDoughnut = () => {
                if (this.filters.analyzed_item === "Pontos")           return 'pontos ';
                if (this.filters.analyzed_item === "Entregas")         return 'entregas ';
                if (this.filters.analyzed_item === "Horas trabalhadas") return '';
                return 'Valores por'
            }

            //Cores das barras e da linha para cada item analisado

            const ItemColor = () => {
                if (this.filters.analyzed_item === "Pontos")           return 'rgba(59, 130, 246, 0.7)';
                if (this.filters.analyzed_item === "Entregas")         return 'rgba(16, 185, 129, 0.7)';
                if (this.filters.analyzed_item === "Horas trabalhadas") return 'rgba(139, 92, 246, 0.7)';
                return 'rgba(16, 185, 129, 0.7)'
            }

            //Minutos para horas em caso de item = horas trabalhadas
            const formatValue = (value) => {
                if (this.filters.analyzed_item === "Horas trabalhadas")
                return this.fmtDuration(value)
                else return value
            }

            const formatMonth = (mes) => {
                const [year, month] = mes.split('-')
                const names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 
                'Julho', 'Agosto', 'Setembro','Outubro', 'Novembro', 'Dezembro']
                return `${names[parseInt(month) - 1]} ${year}`
            }

            const calcAverage = (arr) => {
                if (!arr.length) return 0
                const total = arr.reduce((s, m) => s + getItem(m), 0)
                return Math.round(total / arr.length)
            }

            //Cores das labels no tema dark
            const isDark = document.documentElement.classList.contains('dark')
            const tickColor = isDark ? '#cbd5e1' : '#374151'  // slate-300 : gray-700
            const gridColor = isDark ? '#334155' : '#e5e7eb'  // slate-700 : gray-200

            this.barData = {
            labels: data.by_unit.map(m => (m.gerencia || '').toUpperCase()),
            datasets: [{
                label:  getLabel() + ' Gerência',
                data: data.by_unit.map(m => getItem(m)),
                backgroundColor: ItemColor(),
            }, 
                {
                    label: 'Valor médio',
                    isAverage: true,
                    data: data.by_unit.map(() => calcAverage(data.by_unit)),
                    type: 'line',                               
                    borderColor: 'rgba(255, 99, 132, 0.8)',
                    borderWidth: 2,
                    borderDash: [6, 4],
                    pointRadius: 1,                             
                    fill: false,
                    spanGaps: true,      
                    tension: 0,            
                    order: 0,              
                }
        ]}

            this.lineData = {
                labels: data.by_month.map(m => formatMonth(m.mes)),
                datasets: [{
                    label: getLabel() + ' Mês',
                    data: data.by_month.map(m => getItem(m)),
                    borderColor: ItemColor(),
                    fill: false,
                    tension: 0.3,
                },
                {
                    label: 'Valor médio',
                    isAverage: true,
                    data: data.by_month.map(() => calcAverage(data.by_month)),
                    type: 'line',                               
                    borderColor: 'rgba(255, 99, 132, 0.8)',
                    borderWidth: 2,
                    borderDash: [6, 4],
                    pointRadius: 1,                             
                    fill: false,
                    spanGaps: true,      
                    tension: 0,            
                    order: 0, 
                }
            ]
            }

            this.doghnutData = {
                labels: data.by_activity.map(u => this.geofLabelMap.map[u.entrega] || u.entrega),
                datasets: [{
                    data: data.by_activity.map(m => getItem(m)),
                    backgroundColor: data.by_activity.map(() => 
                    '#' + Math.floor(Math.random()*16777215).toString(16)),
                }]
            }
            this.barData_2 = {
            labels: data.by_user.map(m => m.colaborador),
            datasets: [{
                label: getLabel() + ' Colaborador',
                data: data.by_user.map(m => getItem(m)),
                backgroundColor: ItemColor(),
            
            },
                {
                    label: 'Valor médio',
                    isAverage: true,
                    data: data.by_user.map(() => calcAverage(data.by_user)),
                    type: 'line',                               
                    borderColor: 'rgba(255, 99, 132, 0.8)',
                    borderWidth: 2,
                    borderDash: [6, 4],
                    pointRadius: 1,                             
                    fill: false,
                    spanGaps: true,      
                    tension: 0,            
                    order: 0, 
                }
        ]}

            //Options
            this.doughnutOptions = {
                plugins: {
                    legend: {
                      labels: {
                        color: tickColor
                      }
                    },
                    tooltip: {
                    callbacks: {
                        label: (context) => {
                          const label = context.label || ''
                          const shortLabel = label.length > 40 ? label.slice(0, 40) + '...' : label
                          const value = context.raw || 0

                          const data = context.dataset.data
                          const total = data.reduce((a, b) => a + b, 0)
                          const percentage = total ? ((value / total) * 100).toFixed(1) : 0
                      
                          return `${shortLabel}: ${formatValue(value)} ${getLabelDoughnut()}(${percentage}%)`
                        }
                    }
                    }
                }
                }
                
            this.barOptions = {
                clip: false,
                scales: {
                  y: {
                    ticks: {
                      color: tickColor,
                      callback: (value) => formatValue(value)
                    },
                    grid: {
                      color: gridColor
                    }
                  },
                  x: {
                    ticks: {
                      color: tickColor
                    },
                    grid: {
                      color: gridColor
                    }
                  }
                },
                plugins: {
                    legend: {
                      labels: {
                        color: tickColor
                      }
                    },
                    tooltip: {
                        callbacks: {
                            title: (contexts) => {
                              const ctx = contexts[0]
                              if (ctx.dataset.isAverage) {
                                return 'Média geral'
                              }
                            },
                            label: (context) => {
                                return `${context.dataset.label}: ${formatValue(context.raw)}`
                            }
                        }
                    }
                }
            }

            this.lineOptions = {
                scales: {
                  y: {
                    ticks: {
                      color: tickColor,
                      callback: (value) => formatValue(value)
                    },
                    grid: {
                      color: gridColor
                    }
                  },
                  x: {
                    ticks: {
                      color: tickColor
                    },
                    grid: {
                      color: gridColor
                    }
                  }
                },
                plugins: {
                    legend: {
                      labels: {
                        color: tickColor
                      }
                    },
                    tooltip: {
                        callbacks: {
                            title: (contexts) => {
                              const ctx = contexts[0]
                              if (ctx.dataset.isAverage) {
                                return 'Média geral'
                              }
                            },
                            label: (context) => {
                                return `${context.dataset.label}: ${formatValue(context.raw)}`
                            }
                        }
                    }
                }
            }
            }
        catch (e) {
            console.error(e)
            this.barData = null
            this.barData_2 = null
            this.lineData = null
            this.doghnutData = null
            this.barData = null
            this.barData_2 = null
            this.lineData = null
            this.doghnutData = null
            this.barOptions = null      
            this.lineOptions = null 
            this.doughnutOptions = null
            this.error = e?.response?.data?.error || 'Falha ao carregar registros.'
            this.error = e?.response?.data?.error || 'Falha ao carregar registros.'
        }
    },
    

    resetFilters() {
      if (this.isManager) {
        this.filters = { unit: this.userUnit, q: '', from: '', to: '', collaborator: '', analyzed_item: '' }
      }
      else this.filters = { unit: '', q: '', from: '', to: '', collaborator: '', analyzed_item: '' }
      this.loadCharts()
    },
    formatDate(isoString) {
      if (!isoString) return ''
      const [date, time] = isoString.split('T')
      const [h, m] = time.split(':')
      return `${date.replace(/-/g, '/')} - ${h}:${m}`
    },

// "2026-03-18T15:32:00" → "2026/03/18 - 15:32"

    setPreset(which) {
      const d = new Date()
      const pad = n => String(n).padStart(2, '0')
      const fmt = x => `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`

      if (which === 'today') {
        const s = fmt(d)
        this.filters.from = s
        this.filters.to = s
      } else if (which === 'week') {
        const day = d.getDay() || 7
        const start = new Date(d); start.setDate(d.getDate() - (day - 1))
        const end = new Date(start); end.setDate(start.getDate() + 6)
        this.filters.from = fmt(start)
        this.filters.to = fmt(end)
      } else if (which === 'month') {
        const start = new Date(d.getFullYear(), d.getMonth(), 1)
        const end = new Date(d.getFullYear(), d.getMonth() + 1, 0)
        this.filters.from = fmt(start)
        this.filters.to = fmt(end)
      }
      this.loadCharts()
    },

    sortBy(key) {
      if (this.sort.key === key) {
        this.sort.dir = this.sort.dir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sort.key = key
        this.sort.dir = 'asc'
      }
    },

    fmtDuration(totalMinutes) {
      const t = Number.isFinite(totalMinutes) ? totalMinutes : 0
      const h = Math.floor(t / 60)
      const m = t % 60
      return `${h}h ${m}m`
    },

    async loadUsers (unit='') {
        try {
            const { data } = await axios.get(`${this.apiBase}/admin/overview/users`, { params: { unit } })
            this.colaboradores = data.names
            this.filters.collaborator = ''
        }
        catch(e)  {
            console.error(e)
        }
    }
  },

  watch: {
    'filters.unit' (newUnit) {
        this.loadUsers (newUnit)
    }
  }
}
</script>